export class TcReturnTransaction {
  cardNumber: string = null;
  cus: string = null;
  numAprobacion: string = null;
  accountType: string = null;
  date: string = null;
  franchise: string = null;
  quotes: string = null;
  response: string = null;
  responseCode: string = null;
}
